import { gql } from '@apollo/client'

export const FETCH_GROUP_ROLES = gql`
  query FetchGroupRoles($businessId: ID!) {
    groupRoleIds(groupId: $businessId)
  }
`
